import ProductBar from './ProductBar';
import { useSelector } from 'react-redux';

function Inventory() {
    const { products } = useSelector((state) => state.inventoryManagement.products);

    return (
        <div className='flex flex-col mt-6 mx-5'>
            <div className="flex items-center bg-[#F5F5F5] text-[14px] leading-6 text-[#666666] font-semibold">
                <h2 className='w-[58%] px-[10px] py-2 uppercase'>product</h2>

                <h2 className='w-[13%] px-[10px] py-2 uppercase'>sku code</h2>

                <h2 className='w-[13%] px-[10px] py-2'>Available Stock</h2>

                <h2 className='w-[16%] px-[10px] py-2'>Edit Quantity Available</h2>
            </div>

            {(() => {
                const allVariants = [];

                products.forEach(product => {
                    if (product?.varients?.length > 0) {
                        product.varients.forEach(variant => {
                            allVariants.push({
                                ...variant,
                                VarientName: variant.VarientName || product.product.productName,
                                VarientPrice: variant.VarientPrice,
                                VarientMrp: variant.VarientMrp,
                                VarientImgUrl: variant.VarientImgUrl || product.product.productImgUrls,
                                VarientQuantity: variant.VarientQuantity === "" ? 0 : variant.VarientQuantity ?? 0,
                                VarientSize: variant.VarientSize || product.product.productSpecs?.size,
                                VarientColor: variant.VarientColor || product.product.productSpecs?.color,
                                sku: variant.sku || "",
                                isVariant: true,
                                originalProductId: product.product.id,
                                category: product?.product?.productCategory,
                            });
                        });
                    } else {
                        const pseudoVariant = {
                            id: product.product.id,
                            VarientName: product.product.productName,
                            VarientPrice: product.product.productSellingPrice,
                            VarientMrp: product.product.productMRP,
                            VarientImgUrl: product.product.productImgUrls,
                            VarientQuantity: product.product.productStock || 0,
                            VarientSize: product.product.productSpecs?.size,
                            VarientColor: product.product.productSpecs?.color,
                            sku: product.product.productSKU,
                            isVariant: false,
                            originalProductId: product.product.id,
                            category: product?.product?.productCategory,
                        };
                        allVariants.push(pseudoVariant);
                    }
                });

                const sortedAllVariants = allVariants.sort((a, b) => {
                    const qtyA = a.VarientQuantity === "" ? 0 : a.VarientQuantity ?? 0;
                    const qtyB = b.VarientQuantity === "" ? 0 : b.VarientQuantity ?? 0;
                    return qtyA - qtyB;
                });

                return sortedAllVariants.map(variant => (
                    <ProductBar 
                        key={`${variant.originalProductId}-${variant.id}`} 
                        product={variant} 
                    />
                ));
            })()}
        </div>
    )
}

export default Inventory;
